import type { PropsWithChildren, ReactElement } from 'react';

import {
  BottomLine,
  Circle,
  CircleContainer,
  TopLine,
  VerticalProgressBarInfoContainer,
  VerticalProgressBarContainer,
  VerticalTrackerStepContainer,
} from './styles';
import type { TrackerBarPositionVariant, TrackerBarVariant } from './types';

export interface VerticalTrackerStepProps
  extends PropsWithChildren<{
    barVariant: TrackerBarVariant;
    position: TrackerBarPositionVariant;
    isCurrent: boolean;
    iconOverride?: ReactElement;
  }> {}

export const VerticalTrackerStep = ({
  barVariant,
  position,
  isCurrent,
  children,
  iconOverride,
}: VerticalTrackerStepProps) => {
  const shouldOverrideIcon = !!iconOverride && isCurrent;
  return (
    <VerticalTrackerStepContainer isCurrent={isCurrent}>
      <VerticalProgressBarContainer position={position}>
        {position !== 'first' && <TopLine variant={barVariant} position={position} />}
        <CircleContainer>
          {shouldOverrideIcon && iconOverride}
          {!shouldOverrideIcon && <Circle variant={barVariant} />}
        </CircleContainer>
        {position !== 'last' && <BottomLine variant={barVariant} isCurrent={isCurrent} />}
      </VerticalProgressBarContainer>
      <VerticalProgressBarInfoContainer position={position}>{children}</VerticalProgressBarInfoContainer>
    </VerticalTrackerStepContainer>
  );
};
